export function log(message) {
    if ('console' in window && 'log' in window.console) {
        if (typeof window.console !== 'undefined' && typeof window.console.log !== 'undefined') {
            if (console.log) {
                console.log(message);
            }
        }
    }
}
